import styled from 'styled-components';

const Divider = styled.div`
    width: 100%;
    border-top: 2px dashed ${props => props.theme.palette.additional.border};
    height: 0px;
`;

export default Divider;
